import React from 'react';
import {Header,Footer, Disclaimer as DCM} from '../components/components'

const Disclaimer = () => {
  return (
    <>
    <Header/>
    <DCM/>
    <Footer/>
    </>
  );
};

export default Disclaimer;